module.exports = __webpack_public_path__ + "static/media/home-back.4983bf91.png";